import React, { useMemo } from 'react';
import { FundamentalMovement } from '../../../../Generated/Raven-Demeter';
import bearishIcon from '../../../Assets/Icons/HedgeMonitorPro/bearishCard.svg';
import bullishIcon from '../../../Assets/Icons/HedgeMonitorPro/bullishCard.svg';
import { computeColumnScore } from './columnScore';
import styles from './NewsComponents.module.scss';
import { ArticleWithRating } from './NewsDefinitions';

interface IColumnHeaderProps {
    title: string;
    pairs: ArticleWithRating[];
    getMovement: (pair: ArticleWithRating) => FundamentalMovement | undefined;
    confidenceField: 'supply' | 'demand' | 'sentiment';
}

const ColumnHeader: React.FC<IColumnHeaderProps> = (props) => {
    const score = useMemo(
        () => computeColumnScore(props.pairs, props.getMovement, props.confidenceField),
        [props.pairs, props.getMovement, props.confidenceField],
    );

    return (
        <div className={styles.column_header}>
            <span className={styles.column_header_title}>{props.title}</span>
            <div className={styles.column_header_icons}>
                {score.direction === 'neutral' ? (
                    <span className={styles.column_header_neutral}>—</span>
                ) : (
                    <div className={styles.column_header_icon_group}>
                        <img
                            src={score.direction === 'bull' ? bullishIcon : bearishIcon}
                            alt={score.direction === 'bull' ? 'Bullish' : 'Bearish'}
                            className={styles.column_header_icon}
                        />
                        <span className={styles.column_header_icon_count}>{score.magnitude.toFixed(2)}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ColumnHeader;
